import { ActionType } from 'typesafe-actions';
import {
  getMusicTracksByTag,
  getMusicTracksByTheme,
} from '../../api/videoMaker';
import { Thunk } from '../rootReducer';
import * as actions from './actions';
import {
  getMusicTag,
  getMusicTrackId,
  getVideoStyle,
  getVideoThemeId,
} from './selectors';
import { getThemeStyle } from './themeStyles';
import { IVideoStyle, IVideoStyleOptions } from './types';

function setVideoThemeId(themeId: string): Thunk<ActionType<typeof actions>> {
  return (dispatch) => {
    dispatch(actions.storeVideoThemeId(themeId));
    dispatch(actions.storeVideoStyle(getThemeStyle(themeId)));
  };
}

function setVideoStyle(style: IVideoStyle) {
  return actions.storeVideoStyle(style);
}

function setMusicTag(tag: string) {
  return actions.storeMusicTag(tag);
}

function setMusicTrackId(trackId: string) {
  return actions.storeMusicTrackId(trackId);
}

function getVideoStyleOptions(): Thunk<
  ActionType<typeof actions>,
  Promise<IVideoStyleOptions>
> {
  return async (dispatch, getState) => {
    const state = getState();

    const themeId = getVideoThemeId(state);
    const style = getVideoStyle(state);
    const musicTag = getMusicTag(state);
    let musicTrackId = getMusicTrackId(state);

    if (!musicTrackId) {
      // NOTE: get first track, if track not selected
      const { tracks } = musicTag
        ? await getMusicTracksByTag(musicTag)
        : await getMusicTracksByTheme(themeId);

      musicTrackId = tracks[0].id;
    }

    return {
      themeId,
      style,
      musicTrackId,
    };
  };
}

export {
  setVideoThemeId,
  setVideoStyle,
  setMusicTag,
  setMusicTrackId,
  getVideoStyleOptions,
};
